// Plugin pour ajouter des méthodes toast globales
import Vue from 'vue'

// Méthodes raccourcies pour les toasts
Vue.prototype.$toastSuccess = function(message, options = {}) {
  this.$toast.success(message, {
    timeout: 3000,
    ...options
  })
}

Vue.prototype.$toastError = function(message, options = {}) {
  this.$toast.error(message, {
    timeout: 4000,
    ...options
  })
}

Vue.prototype.$toastWarning = function(message, options = {}) {
  this.$toast.warning(message, {
    timeout: 3500,
    ...options
  })
}

Vue.prototype.$toastInfo = function(message, options = {}) {
  this.$toast.info(message, {
    timeout: 3000,
    ...options
  })
}

// Méthode pour les toasts avec actions (pour usage futur)
Vue.prototype.$toastWithAction = function(message, type = 'info') {
  this.$toast[type](message, {
    timeout: 5000,
    closeButton: true
  })
}

export default {
  // Compatibilité avec l'ancien système
  success: (message) => Vue.prototype.$toastSuccess(message),
  error: (message) => Vue.prototype.$toastError(message),
  warning: (message) => Vue.prototype.$toastWarning(message),
  info: (message) => Vue.prototype.$toastInfo(message),
}
